import React from 'react';
import styled from 'styled-components';

// Styled components for the UI
const CardContainer = styled.div`
  background: #f9f9f9;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%; /* Full width */
//   max-width: 600px;
  margin: 20px 0; /* Removed centering, aligned to left */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

const CardTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: left; /* Left-aligned title */
  margin-bottom: 20px;
  margin-left: 10px; /* Left margin for title */
`;

const ReviewsWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding-bottom: 10px;
  scroll-snap-type: x mandatory;
  padding-left: 10px; /* Left padding to ensure reviews start from left */
`;

const ReviewCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 250px;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Left-align content */
  scroll-snap-align: center;
  flex-shrink: 0;
  margin-right: 10px; /* Right margin between cards */
`;

const UserName = styled.h3`
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 10px 0;
  text-align: left; /* Left-aligned user name */
`;

const StarRating = styled.div`
  font-size: 20px;
  color: #ffd700; /* Gold color */
  margin-bottom: 15px;
  display: flex; /* Align stars in a row */
`;

const ReviewText = styled.p`
  font-size: 16px;
  color: #666;
  text-align: left; /* Left-aligned review text */
  line-height: 1.5;
  margin-bottom: 10px;
`;

const reviews = [
  { name: 'user1', rating: 5, text: 'Absolutely loved the experience! The service was fantastic and the product quality exceeded my expectations.' },
  { name: 'user2', rating: 4, text: 'Great experience, but a little room for improvement. The delivery could be faster.' },
  { name: 'user3', rating: 5, text: 'A wonderful product! I’m really happy with my purchase. Highly recommend it to everyone!' },
  { name: 'user4', rating: 4, text: 'Good value for the price. It works as expected and I’m satisfied with the overall performance.' }
];

const UserReviewsCard = () => {
  return (
    <CardContainer>
      <CardTitle>User Reviews</CardTitle>
      <ReviewsWrapper>
        {reviews.map((review, index) => (
          <ReviewCard key={index}>
            <UserName>{review.name}</UserName>
            <StarRating>
              {[...Array(review.rating)].map((_, i) => (
                <span key={i}>★</span>
              ))}
            </StarRating>
            <ReviewText>{review.text}</ReviewText>
          </ReviewCard>
        ))}
      </ReviewsWrapper>
    </CardContainer>
  );
};

export default UserReviewsCard;
